import React from 'react'
import SectionContainer from '../../../Homepage/SectionContainer'
import BreadCrumb from '../../../component/BreadCrumb/BreadCrumb'
import Explore from '../../../Homepage/Explore'
import Map from '../../../Homepage/Map'
import SmallPage from '../../../Homepage/SmallPage'

const Destination = () => {
  return (
    <>

      <SectionContainer>
        <BreadCrumb items={[
          { title: "HOME", link: "/" },
          { title: "SERVICES", },

        ]} />
        <Explore />
      </SectionContainer>
      <hr className='line-explore' />
      <SectionContainer>
        <Map />
        <hr className='line-style-testprep' />
        <SmallPage countryPage={true} />
      </SectionContainer>

    </>
  )
}

export default Destination
